const smoothScroll = () => {
    
    let header_height = document.querySelector("header").offsetHeight || 0;
    let padding_top = 15;

    if (window.outerWidth < 768) {
        header_height = 0;
        padding_top = -30;
    }

    if (window.location.hash) {

        scroll(0, 0);
        setTimeout(function () { scroll(0, 0); }, 1);

        // smooth scroll to the anchor id
        jQuery('html, body').animate({
            scrollTop: jQuery(window.location.hash).offset().top - header_height - padding_top
        }, 1000, 'swing');

    }

};